import { LanguageHelper } from '@/languages/helper';

export const FLAGS = Object.freeze([
  { value: 'off_topic', label: LanguageHelper('moleculeTranslations.comments.flags.item1') },
  { value: 'inappropriate', label: LanguageHelper('moleculeTranslations.comments.flags.item2') },
  { value: 'spam', label: LanguageHelper('moleculeTranslations.comments.flags.item3') },
  { value: 'other', label: LanguageHelper('moleculeTranslations.comments.flags.item4') },
]);
